import React from "react";
import { useNavigate } from "react-router-dom";
import { FaHandshake } from "react-icons/fa6";
import { HiMiniTrophy } from "react-icons/hi2";

const GameOver = ({ gameOver, winner, scores, players }) => {
  const navigate = useNavigate();
  return (
    <>
      {gameOver && (
        <div id="popup" className="fixed inset-0 flex items-center justify-center z-50">
          <div className="absolute inset-0 bg-gray-900 bg-opacity-50 backdrop-blur-sm"></div>
          <div className="relative flex flex-col items-center justify-center bg-sky-100 md:bg-theme-9 p-3 py-4 rounded-md shadow-lg z-10">
            {winner.length > 1 ? (
              <div className="text-center">
                <div className="text-theme-8 flex justify-center items-center">
                  {" "}
                  <h2 className="text-2xl mb-2 font-bold">It's a Tie </h2>
                  <FaHandshake className=" text-3xl ml-2 pb-1" />
                </div>
                <ul className=" list-inside font-mono font-bold text-lg text-theme-2">
                  {winner.map((player, index) => (
                    <li key={index}>{player}</li>
                  ))}
                </ul>
              </div>
            ) : (
              <div className="text-center ">
                <div className="text-theme-8 flex justify-center items-center">
                  <h2 className="text-2xl mb-2 font-bold">The Winner</h2>
                  <HiMiniTrophy className=" text-3xl ml-1 pb-2" />
                </div>
                <p className="text-center text-theme-2 font-mono font-bold text-xl">
                  <span className="">{winner[0]}</span> [
                  <span>{scores[players.indexOf(winner[0])]}</span>]
                </p>
              </div>
            )}
            <div className="flex w-full justify-between space-x-2 mt-3 px-3">
              <button
                onClick={() => navigate("/")}
                className="shadow-md h-10 p-2 bg-theme-4 text-theme-2 md:bg-theme-6 hover:bg-theme-8 hover:text-theme-6 md:text-theme-8 rounded-md font-semibold"
              >
                Back Home
              </button>
              <button
                onClick={() => window.location.reload()}
                className="shadow-md h-10 p-2 bg-theme-4 text-theme-2 md:bg-theme-6 hover:bg-theme-8 hover:text-theme-6 md:text-theme-8 rounded-md font-semibold"
              >
                Play Again
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GameOver;
